export {
	COLUMN_DEFINITIONS,
	PAGE_SELECTOR_OPTIONS,
	COLLECTION_PREFERENCES,
} from '../ManageWorkflows/ManageWorkflowConstants';
import { CONTENT_DISPLAY_OPTIONS } from '../ManageWorkflows/ManageWorkflowConstants';

const DEFAULT_VISIBLE = ['workflowDefinitionName', 'entityType', 'createdBy'];

export const DEFAULT_PREFERENCES = {
	pageSize: 30,
	contentDisplay: CONTENT_DISPLAY_OPTIONS.map(({ id }) => ({
		id,
		visible: DEFAULT_VISIBLE.includes(id),
	})),
};

const UUID_REGEX =
	/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isLegacyWorkflow = (workflowId: string): boolean => {
	return !UUID_REGEX.test(workflowId);
};
